import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import theme from '../../theme';


export const DateButton = styled(Button)(({ type }) => {

  if (type === 'normal') {
    return {
      color: theme.palette.grey.w500,
      minWidth: 'auto',
      height: '36px',
      borderRadius: '8px',
      border: '1px solid #A9B7C4',
      padding: '0 20px',
      backgroundColor: '#fff',

      '&:hover': {
        borderColor: theme.palette.primary.w400
      }
    }
  }

  return {
    color: theme.palette.text.primary,
    minWidth: 'auto',
    height: '36px',
    borderRadius: '8px',
    border: '1px solid #fff',
    padding: '0 16px',
    backgroundColor: '#fff',
    boxShadow: `0px 2px 4px ${theme.palette.grey.w200}`,

    '&:hover': {
      color: theme.palette.primary.w600,
      borderColor: theme.palette.primary.w400,
      boxShadow: `0px 2px 4px ${theme.palette.grey.w200}`,
    }
  }
})
